import { axiosClient, type IResponse } from '~/common/js/axios';

import { type AxiosRequestConfig } from 'axios';

interface RequestI {
  data?: any;
  params?: any;
  headers?: any;
}

interface BindCardResponse {
  url: string;
  orderNo: string;
  forbiddenCountrys: string[];
}

export function bindCard_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<BindCardResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/bind-card',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

export function replenishUserInfo_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<BindCardResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/replenish-user',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

interface DeleteCardResponse {
  /** 订单号 */
  orderNo: string;
  /** 绑定卡的地址 */
  url: string;
}

export function deleteCard_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<DeleteCardResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/delete-card',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

export interface CardI{
  cardId: string;
  cardType: string; // 卡类型 数字
  cardNumber: string;
  iconUrl: string;
}

interface QueryCardsResponse {
  /**
   * 卡列表
   */
  cardList: CardI[];

  /**
   * 是否存在绑定卡
   */
  existBindingCard: boolean;

  /**
   * 绑卡限制
   */
  bindLimit: number;
}

export function queryCards_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<QueryCardsResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/query-cards',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

/**
 * 用户信息响应接口
 */
export interface UserInfoResponseI {
  birthday: string;
  whiteUser: boolean;
  /**
   * KYC 审核结果
   * pass 放行
   * needKyc1 需要去做 kyc1
   * needKyc2 需要去做 kyc2
   * forbidden 禁止 只有在 forbiddenCountrys 中
   */
  kycAuditResult: string;

  /**
   * 账户类型校验结果
   * pass 放行
   * forbidden 禁止
   * 
   */
  accountTypeCheckResult: string;

  /**
   * 禁止国家列表
   */
  forbiddenCountries: string[];

  /**
   * 是否已验证 kyc2
   */
  kyc2Verify: boolean;

  /**
   * 用户国家
   */
  kycCountry: string;

  /**
   * 邮箱是否已验证
   */
  emailVerify: boolean;

  /**
   * 用户的名字
   */
  firstName: string;

  /**
   * 用户的姓
   */
  lastName: string;

  /**
   * 国家代码
   */
  country: string;

  /**
   * 城市
   */
  city: string;

  /**
   * 街道地址
   */
  street: string;

  /**
   * 省/州代码
   */
  stateCode: string;

  /**
   * 邮编
   */
  zipCode: string;
}

export function userInfo_get(
  options?: RequestI,
  overwriteParams?: AxiosRequestConfig<any>
): Promise<IResponse<UserInfoResponseI>> {
  return axiosClient<any, IResponse<UserInfoResponseI>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/user-info',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: options?.data ?? options?.params ?? {},
  });
}

export interface PriceQuoteResponse {
  crypto: string;
  cryptoUrl: string;
  currency: string;
  price: string;
  amount: string;
  size: string;
  fee: string;
  feeRate: string;
  cardId: string;
  cardNumber: string;
  cardType: string;
  cardIconUrl: string;
  forbiddenCountrys?: string[];
}

export function priceQuote_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<PriceQuoteResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/price-quote',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

export function queryQuote_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<PriceQuoteResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/query-quote',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

interface CreateOrderResponse {
  url: string;
  orderNo: string;
  forbiddenCountrys?: string[];
}

export interface CreateOrderRequest {
  channelType: number;
  side: 'buy' | 'sell';
  currency: string;
  crypto: string;
  quoteType: string; // 表示询价类型 0 市价 1 限价
  amount: string;
  size: string;
  cardId: string;
}
export function createOrder_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<CreateOrderResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/create-order',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

interface OrderListResponse {
  pageInfo: {
    pageCount: number;
    pageIndex: number;
    pageSize: number;
    totalItemCount: number;
  };
  orderList: {
    orderNo: string;
    crypto: string;
    currency: string;
    amount: string;
    size: string;
    price: string;
    createTime: string;
    state: number;
  }[];
}

export function orderList_post(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<OrderListResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/order-list',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: options?.data ?? {},
  });
}

interface OrderDetailResponse {
  orderNo: string;
  crypto: string;
  currency: string;
  amount: string;
  size: string;
  fee: string;
  price: string;
  state: number;
  createTime: string;
}

export function orderDetail_get(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<OrderDetailResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/order-detail',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: options?.data ?? {},
  });
}

interface CardOrderDetailResponse {
  orderNo: string;
  crypto: string;
  currency: string;
  amount: string;
  size: string;
  fee: string;
  price: string;
  state: number; // 0 进行中 1 成功 2 失败
  createTime: string;
  subLabel: string; // 失败类型: 1 支付超时 2 支付失败 3KYC名字未匹配
}


export function cardOrderDetail_get(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<CardOrderDetailResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/card-order-detail',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: options?.data ?? {},
  });
}

/**
 * 获取最近一次失败的卡绑定的交易
 * @param options 
 * @param overwriteParams 
 * @returns 
 */
export function cardOrderDetailFail_get(options?: RequestI, overwriteParams?: AxiosRequestConfig<any>) {
  return axiosClient<any, IResponse<CardOrderDetailResponse>>({
    url: '/gw-api/api/fiat-acquirer-trade/v1/last-fail-card-order',
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: options?.data ?? {},
  });
}
